module.exports = __webpack_public_path__ + "img/9.6335c0d7.png";